import Swiper from "swiper";
import {Autoplay, Grid, Navigation} from "swiper/modules";

export default function initSliders() {
    document.querySelectorAll('.swiper').forEach(startSlider);
}

function startSlider(sliderEl) {
    if (sliderEl.swiper) return;
    const {swiperConfig} = sliderEl.dataset ?? {};

    new Swiper(sliderEl, {
        modules: [
            Navigation,
            Autoplay,
            Grid,
        ],
        navigation: {
            enabled: true,
            prevEl: sliderEl.querySelector('.swiper-prev'),
            nextEl: sliderEl.querySelector('.swiper-next'),
        },
        ...getSwiperConfig(swiperConfig, sliderEl)
    });
}

function getSwiperConfig(swiperConfig, sliderEl) {
    const slidesLength = sliderEl.querySelectorAll('.swiper-slide').length;

    switch (swiperConfig) {
        case 'discover':
            return {
                slidesPerView: 1,
                spaceBetween: 32,
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                    },
                    1024: {
                        slidesPerView: 3,
                    }
                },
                navigation: {
                    enabled: true,
                    prevEl: sliderEl.parentElement.querySelector('.swiper-prev'),
                    nextEl: sliderEl.parentElement.querySelector('.swiper-next'),
                }
            }
        case 'brands':
            return {
                slidesPerView: 2,
                spaceBetween: 32,
                loop: slidesLength >= 4, // slides per view * 2
                breakpoints: {
                    768: {
                        slidesPerView: 3,
                        loop: slidesLength >= 6, // slides per view * 2
                    },
                    1024: {
                        slidesPerView: 5,
                        loop: slidesLength >= 10, // slides per view * 2
                    }
                },
                navigation: {
                    enabled: true,
                    prevEl: sliderEl.parentElement.querySelector('.swiper-prev'),
                    nextEl: sliderEl.parentElement.querySelector('.swiper-next'),
                }
            }
        case 'marketing':
            return {
                slidesPerView: 1,
                spaceBetween: 16,
                loop: slidesLength >= 4, // slides per view * 2
                loopAddBlankSlides: true,
                speed: 500,
                autoplay: {
                    disableOnInteraction: false,
                },
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 32,
                    }
                },
            }
        default:
            return {}
    }
}
